// StartupIndiaRegistration.jsx
import React from "react";

export default function StartupIndiaRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Startup India Registration (DPIIT recognition).";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Startup India
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Startup India Registration (DPIIT Recognition)
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists startups in obtaining recognition under
            the Startup India initiative, helping eligible entities access
            regulatory relaxations, tax benefits, and a compliant growth
            ecosystem. [web:16][web:11]
          </p>
          <p className="text-gray-700">
            The team supports founders in understanding eligibility, preparing
            required documentation, and submitting accurate online applications
            for DPIIT recognition through the Startup India portal. [web:16][web:12]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181534/pexels-photo-1181534.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team working on Startup India registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Startup India Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps gather and format the key details and
              documents needed for Startup India recognition, ensuring that the
              application matches DPIIT requirements. [web:11][web:12]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Certificate of incorporation of the entity (Private Limited,
                  LLP, or Registered Partnership Firm) [web:11][web:16]
                </li>
                <li>PAN card of the startup/entity [web:11][web:12]</li>
                <li>
                  Basic details of founders/directors/partners (identity and
                  contact information) [web:11][web:12]
                </li>
                <li>
                  Brief write‑up / note on the startup, innovation, and
                  scalability of the business model [web:11][web:12]
                </li>
                <li>
                  Website link, pitch deck, or product demo (if available) to
                  support the application [web:11][web:12]
                </li>
                <li>
                  Self‑declarations and any additional undertakings as required
                  on the Startup India portal [web:12][web:15]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers startup‑centric support for the DPIIT
              recognition process, aligning documentation and filings with the
              current Startup India framework. [web:16][web:14]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Knowledge of Startup India Framework
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on eligibility, benefits, and updated norms under the
                  Startup India scheme, including entity type, age, and turnover
                  conditions. [web:16][web:11]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Application Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in correctly filling online forms, attaching the right
                  proofs, and framing the innovation write‑up to reduce chances
                  of rejection or queries. [web:12][web:15]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Compliance Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance from initial documentation and portal registration
                  to post‑recognition guidance on leveraging benefits and
                  staying compliant. [web:16][web:18]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
